import { styled } from '@mui/material';
import { Box } from '../box';
import { MultiSelect as Select } from '../select';
import { Button } from '../button';
export const GroupContainer = styled(Box)(({ theme }) => ({
    marginLeft: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    borderLeft: `2px solid ${theme.palette.divider}`,
}));
export const ConditionRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
}));
export const OperatorSelect = styled(Select)(({ theme }) => ({
    maxWidth: 100,
}));
export const ItemSelect = styled(Select)(({ theme }) => ({
    minWidth: 200,
}));
export const DeleteButton = styled(Button)(({ theme }) => ({
    minWidth: 38,
    width: 38,
    paddingLeft: 8,
    paddingRight: 2,
}));
